import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import Header from '../componenten/Header';
import Navigation from '../componenten/Navigation';
import styled from 'styled-components';
import IsoPut from '../static/fonts/ISOCPEUR.ttf';
import { injectGlobal } from 'styled-components';

injectGlobal`
@font-face {
  font-family: 'ISOCPEUR';
  src: url(${IsoPut});
}
* {
  font-family: 'ISOCPEUR';
}
`;

const Wrapper = styled.section`
  margin: 0 auto;
  max-width: 860px;
  padding: 0px 1.0875rem 1.45rem;
  padding-top: 0;
`;

const Sticky = styled.div`
  padding-top: 40px;
  position: sticky;
  background-color: #fff;
  top: 0;
  z-index: 3;
`;

class TemplateWrapper extends Component {
  render() {
    const navItems = this.props.data.allNavigationJson.edges;

    return (
      <div>
        <Helmet
          title="Hulpia Architecten | architectuur & interieur"
          meta={[
            {
              name: 'description',
              content: 'Hulpia Architecten | architectuur & interieur'
            },
            {
              name: 'keywords',
              content: 'Hulpia Architecten | architectuur & interieur'
            }
          ]}
        />
        <Wrapper>
          <Sticky>
            <Header />
            <Navigation items={navItems} />
          </Sticky>
          {this.props.children({ ...this.props })}
        </Wrapper>
      </div>
    );
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export const query = graphql`
  query fetchData {
    allNavigationJson {
      edges {
        node {
          to
          name
          key
          sub
          subItems {
            to
            name
            key
          }
        }
      }
    }
    allProjectenJson {
      edges {
        node {
          projecten {
            id
            type
            name
            frontImage
            wie
            wat
            waar
            wanneer
            afbeeldingen {
              image
            }
          }
        }
      }
    }
  }
`;

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js